 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		71: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"a369892342905d4d48e30be59f9f27f89834ace2","2":"f4575c9009e379a1a7f0afed5316f8a36e1aac96","3":"710525637e9c4bba9ffb26e60c8b01c4ef355ad7","4":"9d53ee34804e511bc13221c303d8a72f731182ab","5":"4f149b58","7":"component---src-pages-404-js","8":"component---src-pages-about-index-js","9":"component---src-pages-about-news-js","10":"component---src-pages-agreement-privacy-js","11":"component---src-pages-agreement-service-js","12":"component---src-pages-ai-algorithm-js","13":"component---src-pages-ai-enhance-js","14":"component---src-pages-ai-index-js","15":"component---src-pages-ai-price-js","16":"component---src-pages-ai-svg-body-key-point-svg-js","17":"component---src-pages-ai-svg-face-compare-svg-js","18":"component---src-pages-ai-svg-face-detect-svg-js","19":"component---src-pages-ai-svg-human-attr-svg-js","20":"component---src-pages-ai-svg-human-detect-svg-js","21":"component---src-pages-ai-svg-mask-svg-js","22":"component---src-pages-ai-svg-mobile-phone-svg-js","23":"component---src-pages-ai-svg-safety-hat-svg-js","24":"component---src-pages-ai-svg-smoke-svg-js","25":"component---src-pages-compute-deploy-js","26":"component---src-pages-compute-index-js","27":"component---src-pages-compute-introduce-js","28":"component---src-pages-compute-product-index-js","29":"component---src-pages-compute-product-product-detail-js","30":"component---src-pages-compute-product-tab-content-js","31":"component---src-pages-core-algorithm-module-js","32":"component---src-pages-core-components-core-title-index-js","33":"component---src-pages-core-image-module-js","34":"component---src-pages-core-index-js","35":"component---src-pages-core-svg-algorithm-svg-js","36":"component---src-pages-core-svg-search-svg-js","37":"component---src-pages-core-svg-tagging-js","38":"component---src-pages-core-svg-target-svg-js","39":"component---src-pages-core-svg-train-svg-js","40":"component---src-pages-core-video-module-js","41":"component---src-pages-find-pwd-index-js","42":"component---src-pages-home-about-js","43":"component---src-pages-home-ai-js","44":"component---src-pages-home-banner-js","45":"component---src-pages-home-edge-computing-js","46":"component---src-pages-home-home-js","47":"component---src-pages-home-index-js","48":"component---src-pages-home-mobile-home-js","49":"component---src-pages-home-partner-js","50":"component---src-pages-home-platform-js","51":"component---src-pages-home-technology-js","52":"component---src-pages-index-js","53":"component---src-pages-login-index-js","54":"component---src-pages-platform-community-js","55":"component---src-pages-platform-index-js","56":"component---src-pages-platform-park-js","57":"component---src-pages-platform-school-js","58":"component---src-pages-platform-svg-care-svg-js","59":"component---src-pages-platform-svg-face-search-svg-js","60":"component---src-pages-platform-svg-fall-svg-js","61":"component---src-pages-platform-svg-fire-svg-js","62":"component---src-pages-platform-svg-human-search-svg-js","63":"component---src-pages-platform-svg-illegal-stop-svg-js","64":"component---src-pages-platform-svg-invade-svg-js","65":"component---src-pages-platform-svg-night-out-svg-js","66":"component---src-pages-platform-svg-park-patrol-svg-js","67":"component---src-pages-platform-svg-school-patrol-svg-js","68":"component---src-pages-platform-svg-vehicle-search-svg-js","69":"component---src-pages-register-index-js"}[chunkId]||chunkId) + "-" + {"1":"d5ef89c1020b25e16c50","2":"85e32aa4b1f4ea2bd4d7","3":"8f8b6c9ccb309ecc11c2","4":"74db63aea2b485a2c711","5":"3f80b97c4b8b9c70e563","7":"9c62eaa4ee45d5701258","8":"d10e0fe70f64d346f33c","9":"46e5ab1138b30d77218e","10":"505b8a6d0714ba016b33","11":"c0dc7d8b19cd07094829","12":"a570d620388742a1da81","13":"edf5547f80dfda92283a","14":"f8b4ec4a3e6d75a45e16","15":"3255314ddd7b87511a52","16":"79faab52fbd68a288132","17":"4db8a22f87b88b345555","18":"5cd0cccee237ab8c1c95","19":"5c37f9f90c10b33d6a67","20":"71976d1a71b470612fc5","21":"0d222b7712720d58c69a","22":"5dc4faa8d64b5435e8e2","23":"f365422d1eae35ccbbbb","24":"4487d7baa08a6a1bbd05","25":"b1590bd322ff70aaaff3","26":"ad4f0ec41405bef027c3","27":"888937c05ef9080be69e","28":"aefd897af22b126afc90","29":"02caf2ef26bd53dd3d3d","30":"4c4a5b5c78bdaee4bac0","31":"b321f47390c49db16a3d","32":"6ed1b34471422b6b2362","33":"383f5faf7a81afad458d","34":"fac6dd7fd1b5d6768b4b","35":"6ed42a30c7cdcdb692ec","36":"69af664286465e33491d","37":"622fb8ed5a44c9d70f55","38":"543c5d340391d3345236","39":"3f7a59112ead4b905a4f","40":"68508375e858debac67f","41":"b7527b1b7cea9f78ba84","42":"8dfab61834ddf40667fb","43":"40e9dd02671585e12119","44":"7bceef31498a5d808560","45":"8f22a657affd580e28b5","46":"6468604b2e1212a40ee5","47":"1443328bb1f42c9191f8","48":"a644b49fd1bd64367de0","49":"f5dc7ef36b528e23d473","50":"798349b7334f12f7e19e","51":"fe48dff6c04c59e9173b","52":"f74dc4fba37958470cba","53":"1729408383d38a8d0655","54":"13f8806fdb7bbf90786f","55":"8c5e7b63cf35148303ff","56":"c683c859249473f57389","57":"c935b8329d0ca8d577d0","58":"c7a3ecc3c8a2deeb083e","59":"9e274cc59ae7614946ba","60":"da80968ff3fa3e86107a","61":"f7c61b080a3819cbd302","62":"078cd845ad73cafd3d95","63":"a717cc9e882a26c499f6","64":"107a4fd5bf98b4ddd3d4","65":"4174160c707b92bad199","66":"7d5c1400e4aa4a207e9f","67":"c309d350426c02592809","68":"3b9ee95570ef2dfde27f","69":"cbf494288e629fc32628"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dev/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
